export const apiAuthUrl = process.env.REACT_APP_API_AUTH_URL || '';
export const apiUrl = process.env.REACT_APP_API_URL || '';
